import { render } from "./TimelinePost.vue?vue&type=template&id=66d22434"
import script from "./TimelinePost.vue?vue&type=script&lang=js"
export * from "./TimelinePost.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webik150-website-vue/webik150-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__